import { render } from "./EditorBlock.vue?vue&type=template&id=67274d9d&ts=true"
import script from "./EditorBlock.vue?vue&type=script&lang=ts"
export * from "./EditorBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__